// import { toast } from "react-toastify";
import {
  TOAST_TYPES,
  sessionExpireMsg,
  DEFAULT_ERROR_MESSAGE,
} from "@client/shared/constants";
import config from "@client/config";
import { getRCRedirectUri, removeToken, removeUserData } from "@client/utils";

const { rc_client_Id, rc_authorize_uri, apiBaseUrl } = config;
let alreadyRedirected = false;

const redirectToLogin = () => {
  if (alreadyRedirected) return;
  alreadyRedirected = true;

  if (typeof window !== "undefined") {
    removeToken();
    removeUserData()
    window.location.replace(
      getRCRedirectUri(
        rc_authorize_uri,
        rc_client_Id,
        apiBaseUrl,
        `${config.redirectRoute}`
      )
    );
  }
};

const rcApiResponseFormatter = async (
  api,
  defaultMsg = DEFAULT_ERROR_MESSAGE
) => {
  try {
    const response = await api;

    if (response.request.responseType === "arraybuffer") {
      return response;
    }

    // To Do: Add response type "array" check
    if (!response.data.hasOwnProperty("records")) {
      const { data } = response;
      return {
        data,
        error: data.errors,
      };
    }

    const {
      data: { records, errors, token, navigation },
    } = response;

    let formattedResponse = {
      data: records,
      paging: response.data.paging,
      error: errors,
    };

    if (token) formattedResponse.token = token;
    if (navigation) formattedResponse.navigation = navigation;

    return formattedResponse;
  } catch (err) {
    let customErrorMsg = "";
    if (!err.response) {
      return {
        data: null,
        status: null,
        error: err.message || defaultMsg,
      };
    }
    if (
      err &&
      err.response &&
      err.response.status === 401 &&
      err.origin !== "JWKS"
    ) {
      customErrorMsg = sessionExpireMsg;
      // toast[TOAST_TYPES.ERROR](sessionExpireMsg);
      redirectToLogin();

      return {
        data: null,
        error: customErrorMsg,
        status: err.response.status,
      };
    } else if (err && err.response && err.response.status === 429) {
      customErrorMsg =
        "RC Api: Too many requests, please contact system administrator";
      // toast[TOAST_TYPES.ERROR](customErrorMsg);
    } else if (
      err.response.data &&
      Array.isArray(err.response.data.errors) &&
      err.response.data.errors.length > 0
    ) {
      if (typeof err.response.data.errors[0] === "string") {
        err.response.data.error = err.response.data.errors[0];
        delete err.response.data.errors;
      } else {
        err.response.data.errors[0].message = `RC Api: ${
          err.response.data.errors[0].message || defaultMsg
        }`;
      }
    }

    return {
      data: null,
      status:
        err && err.response && err.response.status ? err.response.status : null,
      error: Array.isArray(err.response.data.errors)
        ? err.response.data.errors
        : `RC Api: ${
            (err.response && err.response.data.error) ||
            err.response.data.message ||
            defaultMsg
          }`,
    };
  }
};

const responseFormatter = async (
  api,
  isServer = false,
  defaultMessage = DEFAULT_ERROR_MESSAGE
) => {
  try {
    const { data: response, status, ...request } = await api;

    if (status === 202 && response.error) {
      throw response;
    }

    if (
      request.request.responseType === "blob" ||
      request.headers["content-type"] === "application/zip"
    ) {
      return {
        data: response,
        message: response.message,
        status,
        error: null,
      };
    }

    return {
      data: response && response.data,
      message: response.message,
      status,
      error: null,
    };
  } catch (err) {
    let accessDeniedError = "";
    if (!err.response) {
      console.log(
        "IS NETWORK ERROR",
        err.message && err.message.toLowerCase().indexOf("network error") === -1
      );

      return {
        data: null,
        status: null,
        error:
          err.message &&
          err.message.toLowerCase().indexOf("network error") === -1
            ? err.message || err.error || defaultMessage
            : [{ message: "" }],
      };
    }

    const { status = null, data: response = {} } =
      (err.response && err.response) || {};

    if (status === 401) {
      accessDeniedError = sessionExpireMsg;
      redirectToLogin();
    }

    return {
      data: null,
      status,
      error: response.error || accessDeniedError || defaultMessage,
    };
  }
};

responseFormatter.rc = rcApiResponseFormatter;

export default responseFormatter;
